// This registry renders React elements, so it must be parsed as JSX.
import Phase1ArtifactCardBlock from '@/components/Phase1/ArtifactCardBlock'
import Phase1AutomationCardBlock from '@/components/Phase1/AutomationCardBlock'
import AutomationSetupCardBlock from '@/components/Phase1/AutomationSetupCardBlock'
import Phase1BrowserPreview from '@/components/Phase1/BrowserPreview'
import Phase1ClarificationCardBlock from '@/components/Phase1/ClarificationCardBlock'
import Phase1ConfirmationCardBlock from '@/components/Phase1/ConfirmationCardBlock'
import Phase1ConnectCardBlock from '@/components/Phase1/ConnectCardBlock'
import IntegrationAccessRequestBlock from '@/components/Phase1/IntegrationAccessRequestBlock'

export const phase1BlockRegistryEntries = {
  artifact_card: ({ block, i }) => <Phase1ArtifactCardBlock key={i} block={block} />,
  clarification_card: ({ block, i }) => <Phase1ClarificationCardBlock key={i} block={block} />,
  confirmation_card: ({ block, i }) => <Phase1ConfirmationCardBlock key={i} block={block} />,
  connect_card: ({ block, i }) => <Phase1ConnectCardBlock key={i} block={block} />,
  integration_access_request: ({ block, i }) => <IntegrationAccessRequestBlock key={i} block={block} />,
  automation_card: ({ block, i }) => <Phase1AutomationCardBlock key={i} block={block} />,
  automation_setup_card: ({ block, i }) => <AutomationSetupCardBlock key={i} block={block} />,
  browser_preview: ({ block, i }) => <Phase1BrowserPreview key={i} block={block} />,
}
